require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./jefferson-county-native-american-treatment.json") })
        }
      }, "path---jefferson-county-native-american-treatment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---jefferson-county-native-american-treatment!./.cache/json/jefferson-county-native-american-treatment.json
// module id = 913
// module chunks = 231608221292675